import React from 'react'
import PropTypes from 'prop-types'

const MultiSelect = ({
  contentArray,
  label,
  onSelected,
  multiSelectClass = '',
}) => {
  return (
    <div className="form-row flex-column">
      <div className="form-label">
        <div className="d-flex align-items-center">
          <h3 className="mt-2 mb-2 ml-4 text-dark">{label}</h3>
        </div>
        <hr className="m-0" />
      </div>
      <div className="field">
        <div className="field-container">
          {contentArray.map((entry, index) => {
            const bgHighlight = entry.checked ? 'bg-turquoise-green' : ''
            return (
              <label
                className={`d-block py-2 pointer ${bgHighlight} ${multiSelectClass}`}
                key={index}
              >
                <span className="pl-4 py-2 d-flex align-items-center">
                  <input
                    name="multiselect-item"
                    checked={entry.checked}
                    onChange={onSelected}
                    value={entry.id}
                    type="checkbox"
                    className="pointer"
                  />
                  <span className="ml-3" />
                  {entry.name}
                  <br />
                </span>
              </label>
            )
          })}
        </div>
      </div>
    </div>
  )
}

MultiSelect.propTypes = {
  contentArray: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
  onSelected: PropTypes.func,
  multiSelectClass: PropTypes.string,
}


export default MultiSelect
